import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/equipment';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async main(params: any) {
    return api.main(params);
  }

  @Action
  async sub(params: any) {
    return api.sub(params);
  }

  @Action
  async task(params: any) {
    return api.task(params)
  }

  @Action
  async taskadd(params: any) {
    return api.taskadd(params)
  }

  @Action
  async taskedit(params: any) {
    return api.taskedit(params)
  }

  @Action
  async taskdetail(params: any) {
    return api.taskdetail(params)
  }

  @Action
  async taskdelete(params: any) {
    return api.taskdelete(params)
  }

  @Action
  async salecounter(params: any) {
    return api.salecounter(params)
  }

  @Action
  async addsalecounter(params: any) {
    return api.addsalecounter(params)
  }

  @Action
  async editsalecounter(params: any) {
    return api.editsalecounter(params)
  }

  @Action
  async getsalecounter(params: any) {
    return api.getsalecounter(params)
  }

  @Action
  async deletesalecounter(params: any) {
    return api.deletesalecounter(params)
  }
}
